import React, { useState } from 'react';
import { getFileUrl } from '../../utils/helpers';

interface AuthenticatedImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string;
  fallbackSrc?: string;
}

export const AuthenticatedImage: React.FC<AuthenticatedImageProps> = ({
  src,
  fallbackSrc,
  ...props
}) => {
  const [error, setError] = useState(false);
  const imageUrl = getFileUrl(src);

  const handleError = () => {
    setError(true);
  };

  if (error && !fallbackSrc) {
    return (
      <div className="d-flex align-items-center justify-content-center bg-light" style={{ minHeight: '200px' }}>
        <span className="text-muted">Failed to load image</span>
      </div>
    );
  }

  return (
    <img
      src={error && fallbackSrc ? fallbackSrc : imageUrl}
      onError={handleError}
      {...props}
    />
  );
};
